<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../assets/images/return.png" @click="$router.go(-1)"><span>审批详情</span>
    </div>
    <!-- 审批信息 -->
    <div class="common">
      <div class="approval-title">审批信息</div>
      <div class="cell-row">
        <div class="row">审批类型</div>
        <div class="row">{{approval_info.approval_type_info}}</div>
      </div>
      <div class="cell-row">
        <div class="row">发起人</div>
        <div class="row">{{approval_info.create_member_name}}</div>
      </div>
      <div class="cell-row">
        <div class="row">审批编号</div>
        <div class="row">{{approval_info.approval_num}}</div>
      </div>
      <div class="cell-row">
        <div class="row">单据编号</div>
        <div class="row">{{approval_info.data_num}}</div>
      </div>
      <div class="cell-row">
        <div class="row">部门</div>
        <div class="row">{{approval_info.village_name}} {{approval_info.department_name}}</div>
      </div>
      <div class="cell-row">
        <div class="row">状态</div>
        <div class="row">{{approval_info.status_name}}</div>
      </div>
      <div class="cell-row">
        <div class="flex-1" style="color:blue;text-decoration: underline;" @click="jumpDataInfo()">查看审批内容</div>
      </div>
      <button v-if="show_type == 2" @click="approve(1)">通过</button>
      <button v-if="show_type == 2 && show_back_button == 1" @click="approve(2)">回退</button>
      <button v-if="show_type == 2" @click="approve(3)">驳回</button>
      <button v-if="show_type == 2" @click="approve(4)">终止</button>
      <button v-if="show_type == 1 && show_stop_button == 1" @click="approve(4)">终止</button>
    </div>
    <!-- 审批进度 -->
    <div class="common approval-progress">
      <div class="approval-title">审批进度</div>
      <div style="margin-top: 10px;">
        <div v-for="(detail, detail_key) in approval_info.details" :key="detail_key">
          <div class="cell-row" v-if="detail.status == 3" style="color: #00a65a;">
            <span>{{detail.status_info}}</span>
            <span class="flex-1">{{detail.handle_member_name}}{{detail.transfer_village_info}}({{detail.handle_type_info}})</span>
            <span class="flex-1" style="float: right;color: #999;font-size: 13px;text-align: right;">{{detail.handle_time_info}}</span>
          </div>
          <div class="cell-row" v-else-if="detail.status == 4" style="color: red;">
            <span >{{detail.status_info}}</span>
            <span class="flex-1" >{{detail.set_approver_info}}{{detail.transfer_village_info}}</span>
          </div>
          <div class="cell-row" v-else>
            <span>{{detail.status_info}}</span>
            <span class="flex-1">{{detail.set_approver_info}}{{detail.transfer_village_info}}</span>
          </div>
          <div class="cell-row" style="margin-top: 3px;margin-bottom: 3px;color: #999;">
            <span v-if="detail_key+1 < approval_info.details.length" style="font-size: 10px;">|</span>
            <span v-else></span>
            <span class="flex-1" style="font-size: 13px;word-break: break-all;">
              <span v-if="detail.remark">备注：{{detail.remark}}</span>
              <span v-if="detail.change_content">修改内容：{{detail.change_content}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 加载动画 -->
    <div class="loading" v-if="loading">
      <img src="../../assets/images/loading.gif">
    </div>
    <!-- 审批意见框 -->
    <div class="approve-box" v-if="approvePopup">
      <div class="purchase-content">
        <div class="head-mask">{{approve_title}}</div>
        <div class="purchase-number">备注：
          <textarea v-model="remark" placeholder="请输入审批意见"></textarea>
        </div>
        <div class="purchase-button">
          <button @click="cancel">取消</button>
          <button @click="doApprove">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'ApprovalInfo',
  metaInfo: {
    title: '审批'
  },
  data () {
    return {
      loading: false, // 加载动画
      approval_id: 0,
      approval_detail_id: 0,
      approval_info: {},
      show_type: 2, // 1查看2审批
      show_back_button: 0, // 审批时是否显示回退按钮
      show_stop_button: 0, // 查看时是否显示终止按钮
      approvePopup: false,
      handle_type: 0,
      approve_title: '审批',
      remark: ''
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId', 'appid', 'openid'])
  },
  created () {
    this.loading = true
    this.approval_id = this.$route.query.approval_id
    if (this.$route.query.approval_detail_id) { // 待处理进来的才会有审批详情id
      this.approval_detail_id = this.$route.query.approval_detail_id
    }
    // 如果是从模板消息链接调过来的，检查当前缓存信息是否符合
    if (this.$route.query.from_temp_msg) {
      if (this.$route.query.authorizer_appid !== this.appid || this.$route.query.openid !== this.openid) {
        this.$router.replace({name: 'Login', query: {appid: this.$route.query.authorizer_appid}})
      } else {
        if (this.$route.query.village_id != this.villageId) { // eslint-disable-line
          this.$router.push({name: 'Village', query: {auto_and_back: 1, village_id: this.$route.query.village_id}}) // 去切换小区，并自动返回
        }
      }
    }
    this.getInfo()
  },
  methods: {
    // 获取审批详情
    getInfo (type = 1) {
      this.axios.post('/wechat/approval/ApprovalInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        approval_id: this.approval_id,
        approval_detail_id: this.approval_detail_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.approval_info = res.data.data.approval_info
          this.show_type = res.data.data.show_type
          this.show_back_button = res.data.data.show_back_button
          this.show_stop_button = res.data.data.show_stop_button
          this.loading = false
        }
      })
    },
    jumpDataInfo () {
      if (this.approval_info.approval_type === 2) {
        this.$router.push({name: 'RequisitionDetail', query: {requisition_id: this.approval_info.data_id, come_from_approval: 1}})
      } else if (this.approval_info.approval_type === 4 || this.approval_info.approval_type === 5) {
        this.$router.push({name: 'InvoiceDetail', query: {invoice_id: this.approval_info.data_id, come_from_approval: 1}})
      } else if (this.approval_info.approval_type === 6) {
        this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
          member_id: this.memberId,
          village_id: this.villageId,
          stocktaking_id: this.approval_info.data_id
        }).then((res) => {
          if (res.data.status === 1) {
            var stocktakingInfo = res.data.data.stocktaking_info
            if (stocktakingInfo.type === 1) {
              this.$router.push({name: 'StocktakingInfo', query: {stocktaking_id: this.approval_info.data_id, come_from_approval: 1}})
            } else {
              this.$router.push({name: 'AssetStocktakingInfo', query: {stocktaking_id: this.approval_info.data_id, come_from_approval: 1}})
            }
          }
        })
      } else {
        this.$toast({
          message: '请于后台查看详细审批内容',
          duration: 5000
        })
      }
    },
    // 审批弹窗
    approve (handleType) {
      this.handle_type = handleType
      if (handleType === 1) {
        this.approve_title = '通过'
      }
      if (handleType === 2) {
        this.approve_title = '回退'
      }
      if (handleType === 3) {
        this.approve_title = '驳回'
      }
      if (handleType === 4) {
        this.approve_title = '终止'
      }
      this.approvePopup = true
    },
    // 审批处理
    doApprove () {
      var data = {}
      data.member_id = this.memberId
      data.village_id = this.villageId
      data.approval_id = this.approval_id
      data.remark = this.remark
      var url = ''
      if (this.show_type === 2) {
        url = '/wechat/approval/approve'
        data.approval_detail_id = this.approval_detail_id
        data.handle_type = this.handle_type
      } else {
        if (this.handle_type === 4) {
          url = '/wechat/approval/approvalStop'
        }
      }
      if (url) {
        this.axios.post(url, data).then((res) => {
          if (res.data.status === 1) {
            this.$toast({
              message: '操作成功',
              duration: 5000
            })
            if (this.$route.query.from_temp_msg) {
              this.$router.push({name: 'MyApproval'})
            } else {
              this.$router.go(-1)
            }
          } else {
            this.$toast({
              message: res.data.info,
              duration: 5000
            })
          }
        }).catch(() => {
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
      }
    },
    // 取消
    cancel () {
      this.approvePopup = false
    }
  }
}
</script>
<style scoped>
.approval-title {
  display: flex;
  margin-bottom: 7px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
}
.approval-progress .cell-row {
  align-items: center;
  padding: 0;
}
.approval-progress .cell-row span:first-child{
  width: 50px;
  text-align: center;
  margin-right: 22px;
}
.flex-1 {
  flex: 1;
}
.approve-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 2;
  align-items: center;
  justify-content: center;
  display: flex;
}
.approve-box .purchase-content {
  background-color: #ffffff;
  border-radius: 5px;
  width: 80%;
}
.approve-box .purchase-content .head-mask {
    text-align: center;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #f6f6f6;
    position: relative;
}
.approve-box .purchase-content .purchase-number {
  font-size: 15px;
  padding: 20px 10px 30px 10px;
  display: flex;
  align-items: center;
}
.approve-box .purchase-content .purchase-number textarea {
  border-radius: 15px;
  border: none;
  height: 80px;
  background-color: #f7f7f7;
  outline: none;
  padding: 5px 15px;
  width: 50%;
  flex: 1;
}
.approve-box .purchase-content .purchase-button {
  display: flex;
  font-size: 16px;
}
.approve-box .purchase-content .purchase-button button {
  flex: 1;
  height: 40px;
  background-color: #f7f7f7;
  border: none;
  margin: 0;
}
.approve-box .purchase-content .purchase-button button:first-child {
  border-bottom-left-radius: 5px;
  border-top: 1px solid #f1f1f1;
}
.approve-box .purchase-content .purchase-button button:last-child {
  background-color: #ff7c12;
  color: #ffffff;
  border-bottom-right-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Approval/ApprovalInfo.vue